const leadingSlashRegex = /^\//;

export function trimLeadingSlash(s: string) {
  return s.replace(leadingSlashRegex, "");
}
